import PropTypes from 'prop-types';
import BettingSettingsImpl from './betting-settings.js';
import MojitoCore from 'mojito/core';

/**
 * Component exposing user settings related to betting. Currently it contains settings related
 * to automatic price change acceptance and Quick betslip use.
 *
 * @class BettingSettings
 * @name module
 * @memberof Mojito.Modules.BettingSettings
 */

const propTypes = {
    children: PropTypes.instanceOf(null),
};

export default MojitoCore.Presentation.UIView('BettingSettings', BettingSettingsImpl, propTypes);
